// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2O9ul","dragIcon":"Choice_dragIcon__38yBz","left":"Choice_left__tS1Ip","input":"Choice_input__2qj1G"};